var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9998 16.7787H14.8561V13.3287C14.8561 12.4624 14.5461 11.8699 13.7698 11.8699C13.1786 11.8699 12.8248 12.2706 12.6698 12.6549C12.6136 12.7931 12.5992 12.9837 12.5992 13.1774V16.7787H10.4561C10.4561 16.7787 10.4836 10.9349 10.4561 10.3312H12.5992V11.2443C12.8848 10.8031 13.3936 10.1793 14.5317 10.1793C15.9417 10.1793 16.9998 11.0999 16.9998 13.0812V16.7787ZM8.19812 9.44938H8.18437C7.465 9.44938 7 8.95375 7 8.335C7 7.70312 7.48 7.22062 8.21187 7.22062C8.94562 7.22062 9.3975 7.70312 9.41062 8.335C9.41062 8.95375 8.94562 9.44938 8.19812 9.44938ZM7.12646 16.7788H9.27084V10.3313H7.12646V16.7788ZM12 2C6.47687 2 2 6.4775 2 12C2 17.5231 6.47687 22 12 22C17.5225 22 22 17.5231 22 12C22 6.4775 17.5225 2 12 2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInCircle);
export default __webpack_public_path__ + "static/media/linked_in_circle.ef870508.svg";
export { ForwardRef as ReactComponent };